import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function ProgramsSection() {
  const { t, lang } = useLang();
  const [programs, setPrograms] = useState([]);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/programs"); setPrograms(data); } catch(e){}
  })(); }, []);

  if (programs.length === 0) return null;

  return (
    <section id="programs" data-testid="programs-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 border-t border-[hsl(var(--border))]">
      <p className="text-xs tracking-[0.25em] text-[hsl(var(--muted-foreground))]">{t.programs.eyebrow}</p>
      <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-3 max-w-3xl">{t.programs.title}</h2>
      <p className="mt-4 max-w-2xl text-[hsl(var(--muted-foreground))]">{t.programs.sub}</p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {programs.map((p) => (
          <article
            key={p.id}
            data-testid={`program-tile-${p.slug}`}
            className="group relative overflow-hidden rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--muted))] min-h-[240px]"
          >
            <img src={p.image_url || FALLBACK_IMG} alt={p.label_en} className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-50 group-hover:scale-105 transition-all duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--background))]/95 via-[hsl(var(--background))]/70 to-transparent" />
            <div className="relative h-full p-6 md:p-7 flex flex-col justify-between min-h-[240px]">
              <div className="flex items-start justify-between gap-3">
                <p className="text-xs tracking-[0.25em] uppercase text-[hsl(var(--primary))]">{lang === "zh" && p.label_zh ? p.label_zh : p.label_en}</p>
                <ArrowUpRight className="w-5 h-5 text-[hsl(var(--foreground))] opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight font-medium text-[hsl(var(--foreground))]">{lang === "zh" && p.label_zh ? p.label_zh : p.label_en}</h3>
                <p className="mt-2 max-w-md text-sm text-[hsl(var(--muted-foreground))]">{lang === "zh" && p.desc_zh ? p.desc_zh : p.desc_en}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
